(function () {
  function normalize(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/×/g, 'x')
      .trim()
      .toLowerCase();
  }

  function getTunnelData() {
    const dataEl = document.getElementById('jgm-tunnel-upgrade-data');
    if (!dataEl) return null;

    try {
      return JSON.parse(dataEl.textContent);
    } catch (error) {
      console.error('JGM tunnel data error:', error);
      return null;
    }
  }

  function getSelectedTunnel() {
    const selected = document.querySelector('.jgm-tunnel-depth input[name="properties[Tunnel Depth]"]:checked');
    return selected ? selected.value : 'Standard 8" Tunnel';
  }

  function getSelectedDoorSize(form) {
    const directSelect = form.querySelector('[name="options[Door Size]"]');
    if (directSelect) return directSelect.value;

    const allSelects = document.querySelectorAll('select');
    for (const select of allSelects) {
      const label = document.querySelector(`label[for="${select.id}"]`);
      if (label && normalize(label.textContent).includes('door size')) {
        return select.value;
      }
    }

    return null;
  }

  function findUpgradeVariant(data, doorSize, tunnelDepth) {
    return data.variants.find(function (variant) {
      return normalize(variant.doorSize) === normalize(doorSize)
        && normalize(variant.tunnelDepth) === normalize(tunnelDepth);
    });
  }

  function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2) + ' USD';
}

function getSelectedMainVariantPrice(form) {
  const variantInput = form.querySelector('[name="id"]');
  if (!variantInput) return null;

  const variantId = Number(variantInput.value);

  const variantScript = document.querySelector(
    'variant-selects script[type="application/json"]'
  );

  if (!variantScript) return null;

  const variants = JSON.parse(variantScript.textContent);
  const variant = variants.find(v => Number(v.id) === variantId);

  return variant ? Number(variant.price) : null;
}

function updateDisplayedPrice(form, data) {
  const priceEl =
    document.querySelector('.price .price-item--regular') ||
    document.querySelector('.price .price-item--sale');

  if (!priceEl) return;

  const doorSize = getSelectedDoorSize(form);
  const tunnelDepth = getSelectedTunnel();

  const selectedDoorVariant = data.mainVariants.find(function (variant) {
    return normalize(variant.doorSize) === normalize(doorSize);
  });

  if (!selectedDoorVariant) return;

  let totalPrice = Number(selectedDoorVariant.price);

  if (!normalize(tunnelDepth).includes('standard')) {
    const upgradeVariant = findUpgradeVariant(data, doorSize, tunnelDepth);

    if (upgradeVariant) {
      totalPrice += Number(upgradeVariant.price);
    }
  }

  priceEl.textContent = formatMoney(totalPrice);
}

  function setButtonLoading(form, loading) {
    const button = form.querySelector('[type="submit"]');
    if (!button) return;

    button.disabled = loading;

    if (loading) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const data = getTunnelData();
    if (!data || !data.variants || !data.variants.length) return;

    const forms = document.querySelectorAll('form[action*="/cart/add"]');

    forms.forEach(function (form) {
      if (form.dataset.jgmTunnelUpgrade === 'true') return;
      form.dataset.jgmTunnelUpgrade = 'true';
updateDisplayedPrice(form, data);

document.addEventListener('change', function (event) {
  if (
    event.target.matches('select') ||
    event.target.matches('input[name="properties[Tunnel Depth]"]')
  ) {
    setTimeout(function () {
      updateDisplayedPrice(form, data);
    }, 100);
  }
});
      form.addEventListener('submit', function (event) {
        const tunnelDepth = getSelectedTunnel();

        if (normalize(tunnelDepth).includes('standard')) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const mainVariantInput = form.querySelector('[name="id"]');
        if (!mainVariantInput || !mainVariantInput.value) {
          alert('Please select a door option before adding to cart.');
          return;
        }

        const doorSize = getSelectedDoorSize(form);
        if (!doorSize) {
          alert('Please select a door size before adding to cart.');
          return;
        }

        const upgradeVariant = findUpgradeVariant(data, doorSize, tunnelDepth);
        if (!upgradeVariant) {
          alert('The tunnel upgrade could not be matched to this door size. Please contact us to complete this order.');
          console.error('No tunnel upgrade match:', { doorSize, tunnelDepth, variants: data.variants });
          return;
        }

        const quantityInput =
          form.querySelector('[name="quantity"]') ||
          document.querySelector('quantity-input input[name="quantity"]') ||
          document.querySelector('.quantity__input[name="quantity"]');
        const quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;

        setButtonLoading(form, true);
  fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  body: JSON.stringify({
    id: Number(upgradeVariant.id),
    quantity: quantity
  })
})
.then(function (response) {
  if (!response.ok) throw new Error('Tunnel add failed');

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: Number(mainVariantInput.value),
      quantity: quantity,
      properties: {
        'Tunnel Depth': tunnelDepth
      }
    })
  });
})
.then(function (response) {
  if (!response.ok) throw new Error('Door add failed');
  return response.json();
})
.then(function () {
  window.location.href = '/cart';
})   
          .catch(function (error) {
            console.error(error);
            alert('There was an issue adding the tunnel upgrade. Please try again.');
            setButtonLoading(form, false);
          });
      }, true);
    });
  });

})();